import OrderFinalPage from "./OrderFinalPage";

export default OrderFinalPage;
